import * as React from 'react';
import {AuthService} from "./service/AuthService";
import {Navigate} from "react-router-dom";

export function AuthRequiredRoute({ children }) {
    return AuthService.loggedIn() ? children : <Navigate to="/login" />;
}